import { createSlice } from "@reduxjs/toolkit";
import { BookingType } from "./types";

const seat =
  localStorage.getItem("seats") !== null
    ? JSON.parse(localStorage.getItem("seats")!)
    : [];
const booking =
  localStorage.getItem("booking") !== null
    ? JSON.parse(localStorage.getItem("booking")!)
    : {};

const initialStateValue: BookingType = {
  booking,
  seat,
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState: { value: initialStateValue },
  reducers: {
    setBooking: (state, action) => {
      state.value.booking = { ...state.value.booking, ...action.payload };
      localStorage.setItem("booking", JSON.stringify(state.value.booking));
    },

    setSeat: (state, action) => {
      state.value.seat = action.payload;
      localStorage.setItem("seats", JSON.stringify(state.value.seat));
    },

    clearBooking: (state) => {
      localStorage.removeItem("booking");
      state.value = initialStateValue;
    },
  },
});

export const { setBooking, clearBooking, setSeat } = bookingSlice.actions;
export default bookingSlice.reducer;
